const arkInfo = require('./arkInfo')
const conanInfo = require('./conanInfo')
const rustInfo = require('./rustInfo')
const sevenDaysToDieInfo = require('./sevenDaysToDieInfo')
const terrariaInfo = require('./terrariaInfo')
const unturnedInfo = require('./unturnedInfo')
const armaInfo = require('./armaInfo')
const pixarkInfo = require('./pixarkInfo')
const gmodInfo = require('./gmodInfo')
const spaceEngineersInfo = require('./spaceEngineersInfo')
const starboundInfo = require('./starboundInfo')
const csgoInfo = require('./csgoInfo')
const hurtworldInfo = require('./hurtworldInfo')
const atlasInfo = require('./atlasInfo')
const dayzInfo = require('./dayzInfo')
const outlawsInfo = require('./outlawsInfo')
const hytaleInfo = require('./hytaleInfo')
const heatInfo = require('./heatInfo')
const minecraftInfo = require('./minecraftInfo')
const dbdInfo = require('./dbdInfo')
const scumInfo = require('./scumInfo')
const vRisingInfo = require('./vRisingInfo')

module.exports = [
  arkInfo,
  rustInfo,
  unturnedInfo,
  terrariaInfo,
  sevenDaysToDieInfo,
  armaInfo,
  conanInfo,
  pixarkInfo,
  gmodInfo,
  spaceEngineersInfo,
  starboundInfo,
  csgoInfo,
  hurtworldInfo,
  atlasInfo,
  dayzInfo,
  dbdInfo,
  heatInfo,
  hytaleInfo,
  minecraftInfo,
  outlawsInfo,
  scumInfo,
  vRisingInfo,
]



// WEBPACK FOOTER //
// /opt/build/repo/sanity/schemas/games/index.js